/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} When_Enabled_This_Listing_IsInputs */

const en_when_enabled_this_listing_is = /** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When enabled, this listing is visible in your public portfolio for all visitors to see.`)
};

const id_when_enabled_this_listing_is = /** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat diaktifkan, listing ini terlihat di portofolio publik Anda agar dapat dilihat semua pengunjung.`)
};

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const es_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const fr_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const de_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const ja_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const zh_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const ar_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const it_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const ru_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const pt_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/** @type {(inputs: When_Enabled_This_Listing_IsInputs) => LocalizedString} */
const ko_when_enabled_this_listing_is = en_when_enabled_this_listing_is;

/**
* | output |
* | --- |
* | "When enabled, this listing is visible in your public portfolio for all visitors to see." |
*
* @param {When_Enabled_This_Listing_IsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const when_enabled_this_listing_is = /** @type {((inputs?: When_Enabled_This_Listing_IsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<When_Enabled_This_Listing_IsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_when_enabled_this_listing_is(inputs)
	if (locale === "es") return es_when_enabled_this_listing_is(inputs)
	if (locale === "fr") return fr_when_enabled_this_listing_is(inputs)
	if (locale === "de") return de_when_enabled_this_listing_is(inputs)
	if (locale === "ja") return ja_when_enabled_this_listing_is(inputs)
	if (locale === "zh") return zh_when_enabled_this_listing_is(inputs)
	if (locale === "ar") return ar_when_enabled_this_listing_is(inputs)
	if (locale === "id") return id_when_enabled_this_listing_is(inputs)
	if (locale === "it") return it_when_enabled_this_listing_is(inputs)
	if (locale === "ru") return ru_when_enabled_this_listing_is(inputs)
	if (locale === "pt") return pt_when_enabled_this_listing_is(inputs)
	return ko_when_enabled_this_listing_is(inputs)
});